<template>
	<v-container class="content" fluid>
		<h1 class="display-1 px-3">Werkzeuge</h1>
		<v-tabs>
			<v-tab :key="1"> Gewindeformen </v-tab>
			<v-tab :key="2"> Senkungen </v-tab>
			<v-tab :key="3"> Durchzüge </v-tab>
			<v-tab :key="4"> Zylindersenkungen </v-tab>
			<v-tab-item :key="1">
				<v-data-table
					style="table-layout: fixed"
					:headers="toolsHeaders"
					:items="gewindeVorlagen"
					hide-actions
					:loading="dataLoading"
					class="elevation-1"
				>
					<template slot="items" slot-scope="props">
						<tool-map-component
							:map="props.item"
							:fertiger="fertiger"
							@loading="dataLoading = $event"
						>
						</tool-map-component>
					</template>
				</v-data-table>
			</v-tab-item>
			<v-tab-item :key="2">
				<v-btn
					v-if="canFillDefaultTools()"
					absolute
					top
					right
					title="Definiert alle leeren Vorlagen gemäss Blexon-Schema"
					@click="defineCountersinkTemplates()"
				>
					Definieren
				</v-btn>
				<v-data-table
					style="table-layout: fixed"
					:headers="toolsHeaders"
					:items="senkungVorlagen"
					hide-actions
					:loading="dataLoading"
					class="elevation-1"
				>
					<template slot="items" slot-scope="props">
						<tool-map-component
							:map="props.item"
							:fertiger="fertiger"
							@loading="dataLoading = $event"
						>
						</tool-map-component>
					</template>
				</v-data-table>
			</v-tab-item>
			<v-tab-item :key="3">
				<v-btn
					v-if="canFillDefaultTools()"
					absolute
					top
					right
					title="Definiert alle leeren Vorlagen gemäss Blexon-Schema"
					@click="defineExtrudedThreadTemplates()"
				>
					Definieren
				</v-btn>
				<v-data-table
					style="table-layout: fixed"
					:headers="toolsHeaders"
					:items="durchzugVorlagen"
					hide-actions
					:loading="dataLoading"
					class="elevation-1"
				>
					<template slot="items" slot-scope="props">
						<tool-map-component
							:map="props.item"
							:fertiger="fertiger"
							@loading="dataLoading = $event"
						>
						</tool-map-component>
					</template>
				</v-data-table>
			</v-tab-item>
			<v-tab-item :key="4">
				<v-btn
					v-if="canFillDefaultTools()"
					absolute
					top
					right
					title="Definiert alle leeren Vorlagen gemäss Blexon-Schema"
					@click="defineCylinderCountersinkTemplates()"
				>
					Definieren
				</v-btn>
				<v-data-table
					style="table-layout: fixed"
					:headers="toolsHeaders"
					:items="zylinderVorlagen"
					hide-actions
					:loading="dataLoading"
					class="elevation-1"
				>
					<template slot="items" slot-scope="props">
						<tool-map-component
							:map="props.item"
							:fertiger="fertiger"
							@loading="dataLoading = $event"
						>
						</tool-map-component>
					</template>
				</v-data-table>
			</v-tab-item>
		</v-tabs>
	</v-container>
</template>

<script>
import httpClient from "../store/httpClient";
import ToolMapComponent from "./toolMapComponent.vue";
export default {
	components: {
		"tool-map-component": ToolMapComponent,
	},
	data() {
		return {
			laser: true,
			dataLoading: false,
			formVorlagen: [],
			toolsHeaders: [
				{
					text: "Blexon Bezeichnung",
					align: "rigth",
					sortable: false,
					value: "name",
					width: "10%",
				},
				{
					text: "Name der Vorlage in Boost",
					align: "left",
					sortable: false,
					value: "fertigername",
					width: "20%",
				},
				{
					text: "Text der Vorlage in Boost",
					align: "rigth",
					sortable: true,
					value: "text",
					width: "5%",
				},
			],
		};
	},
	mounted() {
		this.loadVorlagen();
	},
	computed: {
		fertiger() {
			var fertigerId = this.$route.params.fertigerId;
			var currentFertiger = this.$store.state.fertiger.filter((f) => f.id == fertigerId);
			return currentFertiger[0];
		},
		gewindeVorlagen() {
			return this.formVorlagen.filter((f) => f.featureType == 7);
		},
		senkungVorlagen() {
			return this.formVorlagen.filter((f) => f.featureType == 8);
		},
		durchzugVorlagen() {
			return this.formVorlagen.filter((f) => f.featureType == 9);
		},
		zylinderVorlagen() {
			return this.formVorlagen.filter((f) => f.featureType == 13);
		},
	},
	methods: {
		canFillDefaultTools() {
			// this is true if the user is an admin and false otherwise
			return this.fertiger.canManuallyTransmit;
		},
		async loadVorlagen() {
			try {
				this.loading = true;
				const responseVorlagen = await httpClient().get(
					`api/Material/GetFormVorlagen?fertigerId=${this.fertiger.id}`
				);
				this.formVorlagen = responseVorlagen.data;
			} catch (err) {
				console.log("Loading vorlagen failed.");
			} finally {
				this.loading = false;
			}
		},
		async update(toolMap) {
			try {
				this.dataLoading = true;
				await httpClient().post(
					`api/Material/UpdateToolMap?fertigerId=${this.fertiger.id}`,
					toolMap
				);
			} catch (err) {
				console.log(err);
			} finally {
				this.dataLoading = false;
			}
		},
		defineCountersinkTemplates() {
			for (const template of this.senkungVorlagen) {
				if (!template.fertigerName) {
					template.fertigerName = template.blexonName;
					let blexonText = template.blexonName.replace("Senkung ", "");
					blexonText = blexonText.replaceAll(" ", "");
					blexonText = blexonText.replaceAll("in", "s");
					blexonText = blexonText.replaceAll("oben", "+");
					blexonText = blexonText.replaceAll("unten", "-");
					blexonText = blexonText.replaceAll(".", "");
					blexonText = blexonText.replaceAll("mm", "");
					blexonText = blexonText.replaceAll("ab", ">");
					blexonText = blexonText.replaceAll("man", "ms");
					template.fertigerText = blexonText;
					this.update(template);
				}
			}
		},
		defineExtrudedThreadTemplates() {
			for (const template of this.durchzugVorlagen) {
				if (!template.fertigerName) {
					template.fertigerName = template.blexonName;
					let blexonText = template.blexonName.replace("Durchzug ", "");
					blexonText = blexonText.replaceAll(" ", "");
					const indexOben = blexonText.indexOf("oben");
					if (indexOben >= 0) {
						blexonText = blexonText.substring(0, indexOben);
						blexonText = blexonText + "+";
					}
					const indexUnten = blexonText.indexOf("unten");
					if (indexUnten >= 0) {
						blexonText = blexonText.substring(0, indexUnten);
						blexonText = blexonText + "-";
					}

					template.fertigerText = blexonText;
					this.update(template);
				}
			}
		},
		defineCylinderCountersinkTemplates() {
			for (const template of this.zylinderVorlagen) {
				if (!template.fertigerName) {
					template.fertigerName = template.blexonName;
					let blexonText = template.blexonName.replace("Zylindersenkung ", "");
					blexonText = blexonText.replaceAll(" ", "");
					const indexOben = blexonText.indexOf("oben");
					if (indexOben >= 0) {
						blexonText = blexonText.substring(0, indexOben);
						blexonText = blexonText + "+";
					}
					const indexUnten = blexonText.indexOf("unten");
					if (indexUnten >= 0) {
						blexonText = blexonText.substring(0, indexUnten);
						blexonText = blexonText + "-";
					}

					template.fertigerText = blexonText;
					this.update(template);
				}
			}
		},
	},
};
</script>
